<template>
  <v-dialog
    v-model="openTripViewDialog"
    fullscreen
    transition="dialog-bottom-transition"
  >
    <v-card class="pa-4" style="overflow: hidden !important">
      <v-card-title class="card-position-sticky">
        <v-row no-gutters>
          <v-col cols="6" class="d-flex align-center justify-start">
            <span
              class="text-lg-subtitle-1 text-xl-h6 text-uppercase font-weight-black primary--text"
            >
              Planned {{ tripModule.tripPlural }}
            </span>
          </v-col>
          <v-col cols="6" class="d-flex align-center justify-end">
            <v-btn
              class="float-right"
              @click="openTripViewDialog = false"
              small
              fab
              icon
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="pa-0" refs="getheight">
        <v-row class="card-position-absolute" v-if="tripRouteData">
          <v-col cols="2" v-for="(value, name, i) in tripMapData" :key="i">
            <!-- v-if="typeof value != 'object'" -->
            <v-card elevation-0>
              <v-card-title
                v-if="value != null && name != null"
                style="padding: 10px 15px"
              >
                <h5 class="font-weight-bold primary--text text-capitalize">
                  {{ name.replaceAll("_", " ") }}
                </h5>
              </v-card-title>
              <v-card-text v-if="value != null && name != null">
                <h6 class="text-caption primary--text">{{ value }}</h6>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <div>
          <GoogleMap
            v-if="openTripViewDialog"
            mapWidth="100%"
            :mapHeight="containerHeight"
            ref="viewPlannedTrip"
            mapId="plannedTrip"
            :clusterMarkers="true"
            :hasMapInfo="true"
          >
            <template #mapInfo>
              <MapInfo legendType="trip" ref="mapinfo" />
            </template>
          </GoogleMap>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { bus } from "@/main";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import MapInfo from "@/components/BaseComponents/MapInfo.vue";
import { tripModule } from "@/utils/moduleMapping";

export default {
  components: { GoogleMap, MapInfo },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tripMapData: {
      type: Object,
    },
    tripID: {
      required: true,
    },
  },
  computed: {
    openTripViewDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    containerHeight() {
      return `${window.innerHeight - 66}px`;
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.viewTripOnMap();
      }
    },
  },
  data() {
    return {
      tripModule,
      tripRouteData: null,
    };
  },
  methods: {
    viewTripOnMap() {
      bus.$emit("showLoader", true);
      this.$api.tripPlanning
        .getPlanTripRouteData(this.tripID)
        .then((res) => {
          bus.$emit("showLoader", false);
          let setTimer = setInterval(() => {
            if (this.$refs.viewPlannedTrip && this.$refs.viewPlannedTrip.map) {
              clearInterval(setTimer);
              this.$refs.viewPlannedTrip.clearGeoJson();
              this.$refs.viewPlannedTrip.clearMarker();
              this.$refs.viewPlannedTrip.setPlannedRoute(res.data);
              // this.tripRouteData = res.data;
            }
          }, 100);
          // console.log(this.tripRouteData);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
          if (err.message) {
            bus.$emit("showToastMessage", {
              message: err.message,
              color: "error",
            });
          } else {
            bus.$emit("showToastMessage", {
              message: "Error Fetching data!",
              color: "error",
            });
          }
        });
    },
    loadTripOnMapData() {
      // let interval = setInterval(() => {
      //   if (this.$refs.viewPlannedTrip) {
      //     clearInterval(interval);
      //     if (
      //       this.$refs.viewPlannedTrip.map &&
      //       Object.keys(this.tripRouteData).length > 0
      //     ) {
      //       this.$refs.viewPlannedTrip.clearGeoJson();
      //       this.$refs.viewPlannedTrip.clearMarker();
      //       this.$refs.viewPlannedTrip.initMap();
      //       this.$refs.viewPlannedTrip.addMultipleMarkers(
      //         [
      //           ...this.tripRouteData.order_details,
      //           this.tripRouteData.warehouse_details,
      //         ],
      //         "location_type",
      //         true,
      //         ["order_details"]
      //       );
      //       this.$refs.viewPlannedTrip.setFeaturesRoute(
      //         this.tripRouteData.driving_directions.features
      //       );
      //       // if (
      //       //   this.tripRouteData &&
      //       //   this.tripRouteData.home_location_details &&
      //       //   this.tripRouteData.home_location_details.address &&
      //       //   this.tripRouteData.home_location_details.coordinates
      //       // ) {
      //       //   let locations = [];
      //       //   locations.push(this.tripRouteData.home_location_details.coordinates[1])
      //       //   locations.push(this.tripRouteData.home_location_details.coordinates[0])
      //       //    let modifyData = {
      //       //       address : this.tripRouteData.home_location_details.address,
      //       //       location : locations
      //       //     }
      //       //      this.$refs.viewPlannedTrip.loadOrdersActualDeliveryLocation(modifyData);
      //       // }
      //     }
      //   }
      // }, 100);
    },
  },
};
</script>

<style lang="scss" scoped>
.card-position-sticky {
  -webkit-box-shadow: 0px 0px 5px -1px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: 0px 0px 5px -1px rgba(0, 0, 0, 0.19);
  box-shadow: 0px 0px 5px -1px rgba(0, 0, 0, 0.19);
  position: sticky;
  background-color: white;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
}

.card-position-absolute {
  .v-card {
    background-color: #ffffffb3 !important;
  }
  position: absolute;
  z-index: 2;
  left: 0%;
  right: 0;
  width: 100%;
  padding: 20px 40px;
}
</style>
